import { ActionType } from '../../actions-types';
import { message } from 'antd';
import returnDisposalService from '../../../modules/Warehouse/Return/Service/returnDisposal';
import { Action } from '../../actions/return_disposal/index';
import { Dispatch } from 'react';
import {
  returnDetail,
  returnDisposalList
} from '../../reducers/return_disposal/returnDisposalReducer';
import moment from 'moment';
import { formatDateTime } from '@root/utils/helpers/formatDate';

// get list returns
export const handleReturnDisposalList = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.GET_RETURN_DISPOSAL_LIST
    });
    try {
      const resp = await returnDisposalService.getReturnList();
      const payload: any = {
        count: resp.count,
        rowData: resp.data?.map((row: returnDisposalList) => {
          return {
            ...row,
            key: row.id,
            updatedAt: moment(row?.updatedAt).format('YYYY.MM.DD HH:MM:SS A')
          };
        })
      };
      dispatch({
        type: ActionType.GET_RETURN_DISPOSAL_LIST_SUCCESS,
        payload: payload
      });
    } catch (error) {
      if (error instanceof Error) {
        dispatch({
          type: ActionType.GET_RETURN_DISPOSAL_LIST_ERROR,
          payload: error.message
        });
        message.error(error.message);
      }
    }
  };
};

// get list returns with pagination
export const handleReturnDisposalListWithPagination = (
  page: number,
  sort?: boolean,
  fromDt?: string,
  toDt?: string,
  filterBy?: string,
  searchBy?: string,
  filterInput?: string,
  isReturnProduct?: number,
  filter?: string
) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.GET_RETURN_DISPOSAL_LIST
    });
    const resp = await returnDisposalService.getReturnPagination(
      page,
      sort,
      fromDt,
      toDt,
      filterBy,
      searchBy,
      filterInput,
      isReturnProduct,
      filter
    );
    const payload: any = {
      count: resp.count,
      rowData: resp.data?.map((row: returnDisposalList) => {
        return {
          ...row,
          key: row.id,
          updatedAt: formatDateTime(row?.updatedAt)
        };
      })
    };
    dispatch({
      type: ActionType.GET_RETURN_DISPOSAL_LIST_SUCCESS,
      payload: payload
    });
    try {
    } catch (error) {
      if (error instanceof Error) {
        dispatch({
          type: ActionType.GET_RETURN_DISPOSAL_LIST_ERROR,
          payload: error.message
        });
        message.error(error.message);
      }
    }
  };
};

// get return detail
export const handleReturnDisposalDetail = (id: string) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.GET_RETURN_DISPOSAL_DETAIL
    });
    try {
      const resp = await returnDisposalService.getDetailReturn(id);
      const payload: returnDetail = resp;
      dispatch({
        type: ActionType.GET_RETURN_DISPOSAL_DETAIL_SUCCESS,
        payload: payload
      });
    } catch (error: any) {
      if (error instanceof Error) {
        dispatch({
          type: ActionType.GET_RETURN_DISPOSAL_DETAIL_ERROR,
          payload: error.message
        });
        message.error(error.message);
      }
    }
  };
};

// put return save
export const handleSaveReturn = (
  id: string,
  status: string,
  updateDate?: string,
  courier?: string,
  trackingNumber?: string,
  deliveryStatus?: string
) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.PUT_RETURN_DISPOSAL_SAVE
    });
    try {
      const resp = await returnDisposalService.putReturnSave(
        id,
        status,
        updateDate,
        courier,
        trackingNumber,
        deliveryStatus
      );
      const payload: returnDetail = resp;
      dispatch({
        type: ActionType.PUT_RETURN_DISPOSAL_SAVE_SUCCESS,
        payload: payload
      });
      const respReturn = await returnDisposalService.getDetailReturn(id);
      const payloadReturn: returnDetail = respReturn;
      dispatch({
        type: ActionType.GET_RETURN_DISPOSAL_DETAIL_SUCCESS,
        payload: payloadReturn
      });
    } catch (error) {
      console.log(error, 'error');

      if (error instanceof Error) {
        dispatch({
          type: ActionType.PUT_RETURN_DISPOSAL_SAVE_ERROR,
          payload: error.message
        });
        // message.error(error.message);
      }
    }
  };
};
